import styled from 'styled-components';

export const BqPage = styled.div`
	text-align: left;
`;

export const BqSec = styled.div`
	padding: 36px var(--pad) 30px;
	border-top: 1px solid var(--hair);

	.bq-lab {
		font-size: 13px;
		font-weight: 700;
		letter-spacing: 2px;
		text-transform: uppercase;
		color: var(--mut);
		margin-bottom: 6px;
	}
`;

/** Giant Fjalla numbers with the teal highlighter swipe. */
export const BqNums = styled.div`
	display: flex;
	align-items: baseline;
	gap: clamp(28px, 4.5vw, 68px);
	flex-wrap: wrap;
	padding: 14px 0 4px;

	button {
		position: relative;
		font-family: var(--fd);
		font-size: clamp(54px, 6.5vw, 104px);
		line-height: 1;
		background: none;
		border: none;
		cursor: pointer;
		color: var(--mut);
		transition:
			color 0.2s,
			transform 0.18s;
		padding: 0 4px 8px;
	}

	button:hover {
		color: var(--ink);
		transform: translateY(-3px);
	}

	button.on {
		color: var(--ink);
	}

	button span {
		position: relative;
		z-index: 1;
	}

	button::after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: 4px;
		height: 16px;
		background: var(--teal);
		border-radius: var(--r-xs);
		transform: scaleX(0);
		transform-origin: left;
		transition: transform 0.3s cubic-bezier(0.2, 0.65, 0.25, 1);
	}

	button.on::after {
		transform: scaleX(1);
	}

	@media (max-width: 720px) {
		justify-content: center;
	}
`;

/** Question-type rows with mock-slide illustrations. */
export const BqTypes = styled.div`
	padding-top: 6px;

	.row {
		display: flex;
		align-items: center;
		gap: clamp(16px, 3vw, 36px);
		padding: 14px 0;
		border-top: 1px dashed rgba(var(--ink-rgb), 0.12);
		cursor: pointer;
	}

	.row:first-of-type {
		border-top: none;
	}

	.row:focus-visible {
		outline: 2px solid var(--teal-dark);
		outline-offset: 4px;
		border-radius: var(--r-xs);
	}

	.tname {
		font-family: var(--fd);
		font-size: clamp(23px, 2.9vw, 38px);
		color: var(--ink);
		text-transform: uppercase;
		letter-spacing: 0.3px;
		flex: 1;
	}

	.row.off .tname {
		color: var(--mut);
	}

	.qtill {
		display: block;
		background: var(--panel);
		border-radius: var(--r-ctl);
		color: var(--ink);
		width: 118px;
		aspect-ratio: 120 / 76;
		flex-shrink: 0;
	}

	.row.off .qtill {
		opacity: 0.55;
	}

	.row.fixed {
		cursor: default;
	}

	.row.fixed .tick-fixed {
		opacity: 0.5;
	}

	.bq-note {
		font-family: var(--fh);
		font-weight: 600;
		font-size: clamp(24px, 2.2vw, 31px);
		color: var(--gold-ink);
		transform: rotate(-1.2deg);
		white-space: nowrap;
	}

	@media (max-width: 720px) {
		.row {
			flex-direction: column;
			gap: 12px;
			text-align: center;
			padding: 20px 0;
		}

		.tname {
			flex: none;
		}

		.bq-note {
			white-space: normal;
		}
	}
`;
